import cal from "../../assets/images/snake.png";
import Mchat from "../../assets/images/chatappM.png";
import Social from "../../assets/images/Social.png";
import tour from "../../assets/images/love.png";
import food from "../../assets/images/food.png";
import chat from "../../assets/images/chat.png";
import ml from "../../assets/images/face1.png";
import Pchat from "../../assets/images/pchat.png";
import alumni from "../../assets/images/alumni.png";
import booking from "../../assets/images/booking.png";
import edu from "../../assets/images/edu.png";
import trans from "../../assets/images/trans.png";
import { GoDotFill } from "react-icons/go";

export const projectData = {
  "Feed Forward": {
    title: "Feed Forward",
    description: (
      <>
        <GoDotFill /> Feed Forward is a groundbreaking mobile application
        designed to combat food waste and address food insecurity. The app's
        primary objective is to ensure that quality food resources are not
        squandered by connecting individuals and NGO's with excess food to those
        in need of it. <br />
        <br />
        <GoDotFill /> One of the most salient features of Feed Forward is its
        donation platform, which empowers restaurants, grocery stores, and other
        food-related businesses to donate surplus food to nearby charitable
        organizations, food banks, and shelters. This feature is vital in
        reducing food waste and ensuring that valuable food resources are used
        effectively to alleviate hunger in communities. <br />
        <br />
        <GoDotFill /> In addition to tackling food waste, Feed Forward serves as
        a robust platform for addressing food insecurity. Through the app, users
        can request assistance with food and have their needs met by generous
        donors within their local communities. Further, monetary donations can
        be made via the app, which are then used to provide financial support to
        those who lack access to sufficient food resources.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Feed-Forward-App",
    image: food,
  },
  "Insight Mate": {
    title: "Insight Mate",
    description: (
      <>
        The app is a combination of various AI features including object
        detection and recognition, chatbot functionality, pose detection,
        text-to-speech, barcode scanner, voice-to-text search, digital ink
        recognition, text-to-image, and image search. The object detection
        feature identifies and names objects in images captured by the user,
        while the chatbot allows for natural language communication. Pose
        detection can identify and track the human body, providing users with
        shape suggestions for improving their posture. Text-to-speech converts
        written text into spoken words, and barcode scanner enables users to
        scan and decode product barcodes for more information. Voice-to-text
        search allows users to search for information using voice commands,
        while digital ink recognition detects and records the user's hand
        gestures. Text-to-image converts written text into images, and image
        search enables users to search for images using keywords. Together,
        these features provide users with a wide range of tools for
        communication, information gathering, and image recognition.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Hackathon-Insight-Mate",
    image: chat,
  },
  "Connect X": {
    title: "Connect X",
    description: (
      <>
        Welcome to Connect X, your go-to platform for seamless and interactive
        connections! Connect X is a mobile application designed to foster
        communication, collaboration, and networking among users. Whether you're
        looking to connect with friends, colleagues, or like-minded individuals,
        Connect X provides a user-friendly and feature-rich environment to
        enhance your social and professional connections.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Connect-X",
    image: alumni,
  },
  "Chat With Me": {
    title: "Chat With Me",
    description: (
      <>
        Welcome to the Flutter Chat App repository! This project is a real-time
        chat application built using Flutter and Socket.IO for WebSocket
        communication. It provides users with the ability to join chat rooms,
        send messages, and view a list of online users.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Flutter_Chat_App",
    image: Pchat,
  },
  "Social Sense": {
    title: "Social Sense",
    description: (
      <>
        SocialSense: Real-time hate speech analytics for responsible online
        interaction. Our mobile app uses ML models to analyze content, provide
        tactful alerts, and promote positive language. Join us in creating a
        pioneer platform for social media responsibility
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/SocialSense",
    image: Social,
  },
  "Chat App": {
    title: "Mern Stack Chat App",
    description: (
      <>
        Introducing our MERN Chat App: Real-time communication, secure
        messaging, and collaboration. With MongoDB, Express, React, Node, and
        WebSocket via Socket.IO, enjoy encrypted chats, role-based access, and
        instant notifications. Connect, collaborate, redefine communication:{" "}
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Chat_App",
    image: Mchat,
  },
  "Booking Website": {
    title: "Booking Website",
    description: (
      <>
        <GoDotFill /> Experience the convenience and luxury of seamless travel
        planning with our cutting-edge booking platform. Discover a world of
        possibilities as you explore our extensive collection of accommodations,
        from cozy cottages to luxurious resorts, meticulously curated to cater
        to every traveler's unique taste and preference. <br />
        <br />
        <GoDotFill /> Powered by the latest technologies, our platform offers
        intuitive navigation and real-time updates, ensuring a hassle-free
        booking experience. Dive into a realm of unparalleled convenience as you
        effortlessly browse through our vast selection of destinations, complete
        with detailed descriptions, stunning visuals, and user-generated
        reviews. <br />
        <br />
        <GoDotFill /> With our robust backend infrastructure built on Node.js
        and Express.js, coupled with the dynamic capabilities of the MERN stack,
        we deliver lightning-fast performance and unmatched reliability.
        Seamlessly sync your preferences across devices, and enjoy personalized
        recommendations tailored to your travel interests. <br />
        <br />
        <GoDotFill /> Whether you're planning a relaxing getaway, an adventurous
        expedition, or a business trip, our platform simplifies the journey from
        dream to destination. Join the millions of travelers who trust us to
        make their travel dreams a reality. Your next unforgettable experience
        awaits with our innovative booking solution.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Booking_Website",
    image: booking,
  },
  Transcribe: {
    title: "Transcribe",
    description: (
      <>
        This repository contains four machine learning models for Neural Machine
        Translation (NMT): <br />
        <br />
        <GoDotFill className="blue" /> <span className="blue">Helsinki-MT</span>
        : This is a Transformer-based NMT model trained on the Helsinki Corpora.
        It supports translation between a variety of language pairs. <br />
        <br />
        <GoDotFill className="blue" />{" "}
        <span className="blue">Meta-NLLB-200</span>: This is a state-of-the-art
        NMT model from Meta AI that supports translation between 200 languages.
        It is based on the No Language Left Behind (NLLB) project, which aims to
        develop high-quality machine translation capabilities for most of the
        world's languages. <br />
        <br />
        <GoDotFill className="blue" /> <span className="blue">Transformer</span>
        : This is the original Transformer model for NMT, which was first
        introduced in the paper "Attention is All You Need" by Vaswani et al.
        (2017). <br />
        <br />
        <GoDotFill className="blue" />{" "}
        <span className="blue">Neural Machine Translation using LSTM</span>:
        This is a template for creating a LLM model using LSTM. <br />
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/TranScribe",
    image: trans,
  },
  "Snake Game": {
    title: "Snake Game",
    description: (
      <>
        This is a classic arcade-style Snake game developed using C++
        programming language. The game features a snake that moves around the
        screen and grows in length as it eats food, which appears randomly on
        the screen.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/CPP-Snake-Game-Project",
    image: cal,
  },
  "Face Recognition": {
    title: "Face Recognition",
    description: (
      <>
        <GoDotFill /> Embark on a groundbreaking journey into the world of
        artificial intelligence with our innovative face recognition project.
        Utilizing state-of-the-art machine learning algorithms and computer
        vision techniques, our platform offers cutting-edge facial recognition
        capabilities that redefine the way we interact with technology. <br />
        <br />
        <GoDotFill /> Immerse yourself in a world where biometric authentication
        meets unparalleled convenience. Our robust system accurately identifies
        individuals in real-time, enabling seamless access control, personalized
        experiences, and enhanced security across a myriad of applications.
        <br />
        <br />
        <GoDotFill />
        Built on a foundation of deep learning, our project leverages
        convolutional neural networks (CNNs) to extract intricate facial
        features and patterns, enabling precise recognition even in varying
        lighting conditions, poses, and facial expressions. <br />
        <br />
        <GoDotFill /> Experience the power of modern technology as our platform
        learns and adapts to individual faces, continuously refining its
        accuracy and performance over time. With a user-friendly interface and
        seamless integration capabilities, our solution offers unparalleled
        versatility and scalability across industries. <br />
        <br />
        <GoDotFill /> From secure access control in corporate environments to
        personalized customer experiences in retail and entertainment, the
        possibilities are limitless.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Face-Recognition",
    image: ml,
  },
  "Education App": {
    title: "Backend of Education App",
    description: (
      <>
        <GoDotFill /> Embark on a transformative journey in the realm of
        education technology with our comprehensive backend and API solution.
        Our platform offers a robust foundation for building a cutting-edge
        education app that revolutionizes the way students learn, teachers
        instruct, and administrators manage educational resources.
        <br />
        <br />
        <GoDotFill /> Harnessing the power of the MERN (MongoDB, Express.js,
        React.js, Node.js) stack, our backend architecture delivers unparalleled
        performance, scalability, and flexibility. Seamlessly integrate
        essential features such as user authentication, authorization, and
        role-based access control to ensure secure access to educational content
        and resources.
        <br />
        <br />
        <GoDotFill /> Dive into the realm of seamless payment integration with
        our built-in payment gateway solutions, facilitating hassle-free
        transactions for course enrollments, subscriptions, and premium content
        access. With support for various payment methods and currencies, our
        platform caters to a global audience with ease.
        <br />
        <br />
        <GoDotFill /> Empower educators with intuitive tools for creating,
        managing, and delivering engaging course content. Our API facilitates
        seamless uploading, storage, and retrieval of multimedia resources,
        including videos, documents, and presentations, leveraging cloud storage
        solutions like Cloudinary for optimal performance and scalability.
        <br />
        <br />
        <GoDotFill /> Foster collaborative learning environments with features
        for student-teacher interaction, assignment submissions, quizzes, and
        assessments. Leverage advanced analytics and reporting capabilities to
        track student progress, identify learning gaps, and personalize learning
        experiences for optimal outcomes.
        <br />
        <br />
        <GoDotFill /> With a focus on accessibility and inclusivity, our backend
        solution supports multi-language support, ensuring a seamless experience
        for diverse user demographics. Additionally, our platform complies with
        industry-standard security protocols, including data encryption, SSL/TLS
        protection, and regular security audits to safeguard user data and
        privacy.
        <br />
        <br />
        <GoDotFill /> Join us on a mission to reshape the future of education
        with our comprehensive backend and API solution, empowering educators
        and learners worldwide to unlock their full potential in a digital-first
        learning environment.
        <br />
        <br />
        <GoDotFill /> This description highlights key features such as payment
        integration, user authentication, multimedia content management, and
        analytics, showcasing the platform's capabilities and benefits for
        educators, students, and administrators.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/Backend_Project",
    image: edu,
  },
  "Tour Travels": {
    title: "Tour & Travels",
    description: (
      <>
        Looking for travel inspiration in India? Love India is the perfect
        repository for you! Here, you will find all the information you need
        about the best tourist destinations in India.
      </>
    ),
    githubLink: "https://github.com/Mayank-kr-sh/LoveIndia",
    image: tour,
  },
};
